<template>
  <div>
    <div class="d-none d-md-block">
      <v-timeline align-top dense v-if="!isTimeoffEmpty()">
        <timeline-regular :data="{ ...timeoffs.today, title: 'Today' }" />
        <timeline-regular :data="{ ...timeoffs.tomorrow, title: 'Tomorrow' }" />
        <timeline-regular :data="{ ...timeoffs.next, title: 'Upcoming' }" />
      </v-timeline>
      <div v-else>
        <v-img src="/no-timeoffs.svg" :contain="true" height="300" />
      </div>
    </div>

    <div class="d-md-none">
      <div v-if="!isTimeoffEmpty()">
        <timeline-small :data="{ ...timeoffs.today, title: 'Today' }" />
        <v-divider />
        <timeline-small :data="{ ...timeoffs.tomorrow, title: 'Tomorrow' }" />
        <v-divider />
        <timeline-small :data="{ ...timeoffs.next, title: 'Upcoming' }" />
      </div>
      <div v-else>
        <v-img src="/no-timeoffs.svg" :contain="true" height="300" />
      </div>
    </div>
  </div>
</template>

<script>
import TimelineRegular from "@/views/protected/dashboard/timeline-regular";
import TimelineSmall from "@/views/protected/dashboard/timeline-small";

export default {
  name: "ActivitiesTimeoff",
  props: ["timeoffs"],
  components: {
    TimelineSmall,
    TimelineRegular,
  },
  methods: {
    isTimeoffEmpty() {
      if (!this.timeoffs) return true;
      if (
        !this.timeoffs.next &&
        !this.timeoffs.today &&
        !this.timeoffs.tomorrow
      ) {
        return true;
      }
      return (
        !this.timeoffs.next.data &&
        !this.timeoffs.tomorrow.data &&
        !this.timeoffs.today.data
      );
    },
  },
};
</script>

<style scoped>
</style>
